import { getControllerApiVersion } from './utils.js';

const FORTY_EIGHT_HOUR_HISTORY_API_MIN = 'BAG';
const FORTY_EIGHT_HOUR_HISTORY_TRANSLATION_KEYS = {
  history_type_daily: 'history_type_48h',
  erase_daily_history: 'erase_48h_history',
  action_erase_daily_history_text: 'action_erase_48h_history_text',
  erase_daily_history_in_progress: 'erase_48h_history_in_progress',
  erase_daily_history_successful: 'erase_48h_history_successful'
};

export function uses48HourHistoryTerminology(controller) {
  if (controller?.simulation) {
    return true;
  }

  return getControllerApiVersion(controller).localeCompare(FORTY_EIGHT_HOUR_HISTORY_API_MIN) >= 0;
}

export function getHistoryTranslationKey(controller, translationKey) {
  if (!uses48HourHistoryTerminology(controller)) {
    return translationKey;
  }

  return FORTY_EIGHT_HOUR_HISTORY_TRANSLATION_KEYS[translationKey] ?? translationKey;
}
